<template>
	<div>
		<div v-show="!!alertText" class="alert">
			{{ alertText }}
		</div>
		<div class="component-input-image" :style="urlMiniature ? componentStyle : ''">
			<div class="image-block">
				<div class="icon" v-if="!urlMiniature">
					<i class="fal fa-image"></i>
					<div class="title">Selecione uma imagem</div>
				</div>
			</div>
			<input type="file" class="button-add" :accept="acceptImgs" multiple @change="uploadImage" />
		</div>
		<div class="observation" v-if="!!observation">
			<small>{{ observation }}</small>
		</div>
	</div>
</template>

<script>
	import helpers from '@/mixins/helpers'
	import { storage } from '@/services/storage'

	export default {
		name: 'ui-upload-image',

		mixins: [helpers],

		props: {
			imagePath: {
				type: String,
				required: false,
				default: ''
			},
			imageUrl: {
				type: String,
				required: false,
				default: ''
			},
			maxSize: {
				type: Number,
				required: false,
				default: 1536000
			},
			observation: {
				type: String,
				required: false,
				default: ''
			},
			maxWidth: {
				type: Number,
				required: false,
				default: 1920
			},
			maxHeight: {
				type: Number,
				required: false,
				default: 1080
			},
			acceptImgs: {
				type: String,
				default: '.jpg, .jpeg, .png'
			}
		},

		data() {
			return {
				localImageUrl: '',
				imageArrayData: null,
				formData: null,
				alertText: ''
			}
		},

		computed: {
			urlMiniature() {
				if (this.localImageUrl) return this.localImageUrl

				if (this.imagePath)
					return this.getImgCDN(this.imagePath + `?v=${storage.get('cache_version')}`)

				if (this.imageUrl) return this.imageUrl

				return ''
			},

			componentStyle() {
				return { backgroundImage: `url('${this.urlMiniature}')`, border: `none` }
			}
		},

		methods: {
			uploadImage($e) {
				this.alertText = ''

				this.imageArrayData = $e.target.files
				const selectedImage = this.imageArrayData[0]

				if (selectedImage.size >= this.maxSize) {
					this.alertText = 'Imagem com tamanho acima do permitido.'
					return
				}

				const fr = new FileReader()
				fr.readAsDataURL(selectedImage)
				fr.onload = (event) => {
					onLoadImage(event)
				}

				const onLoadImage = (e) => {
					const image = new Image()

					image.onload = () => {
						if (image.width > this.maxWidth || image.height > this.maxHeight) {
							this.alertText = 'Imagem com dimensão acima do permitido.'
							return
						}

						this.localImageUrl = e.target.result

						this.formData = new FormData()
						this.formData.append('name', selectedImage.name)
						this.formData.append('file', selectedImage)

						this.$emit('input', this.formData)
					}

					image.src = e.target.result
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
